import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_GroupTable = _resolveComponent("GroupTable");
    const _component_WorkerListDialog = _resolveComponent("WorkerListDialog");
    return (_openBlock(), _createElementBlock("div", null, [
        _createVNode(_component_GroupTable),
        _createCommentVNode(" 라이더 확인 다이얼로그 "),
        _createVNode(_component_WorkerListDialog)
    ]));
}
